module.exports = __webpack_public_path__ + "img/setting-step-two.ccec2762.png";